import { Container } from '../CustomFieldsTable.styles';

const UsersTableListError = () => {
  return <Container>Error on load invitations</Container>;
};

export { UsersTableListError };
